var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-down-text pb-5 cursor-default"},[_c('div',{staticClass:"demo section mt-16 cursor-default",class:{'lightened' : _vm.isLightened},attrs:{"id":"section04"}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"primary--text text--lighten-3 cursor-default"},[_c('span')])
}]

export { render, staticRenderFns }